var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIcon2(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 64 64",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M12.621,14.584l-1.588-1.217a18.505,18.505,0,0,0-1.689,2.64l1.769.931A16.623,16.623,0,0,1,12.621,14.584Z",
    id: "id_112",
    style: {
      fill: "rgb(71, 197, 222)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.138,11.049,14.5,12.512a16.833,16.833,0,0,1,2.2-1.73l-1.1-1.67A18.854,18.854,0,0,0,13.138,11.049Z",
    id: "id_113",
    style: {
      fill: "rgb(77, 213, 240)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.441,40.517l-1.8.873c.42.87.8,1.757,1.12,2.638l1.879-.685A30.139,30.139,0,0,0,16.441,40.517Z",
    id: "id_114",
    style: {
      fill: "rgb(70, 208, 235)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.233,25.024l-2,.053a18.589,18.589,0,0,0,.348,3.115l1.961-.39A16.475,16.475,0,0,1,9.233,25.024Z",
    id: "id_115",
    style: {
      fill: "rgb(85, 223, 250)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.454,31.205a18.465,18.465,0,0,0,1.373,2.817L11.544,33a16.434,16.434,0,0,1-1.225-2.513Z",
    id: "id_116",
    style: {
      fill: "rgb(87, 223, 250)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.415,21.949l1.981.285a16.281,16.281,0,0,1,.631-2.721l-1.9-.617A18.437,18.437,0,0,0,7.415,21.949Z",
    id: "id_117",
    style: {
      fill: "rgb(91, 225, 252)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.156,9.438A17.044,17.044,0,0,1,21.8,8.522l-.5-1.937A18.847,18.847,0,0,0,18.346,7.61Z",
    id: "id_118",
    style: {
      fill: "rgb(67, 198, 224)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.19,35.29l-1.552,1.26a22.284,22.284,0,0,1,1.63,2.323l1.7-1.049A23.8,23.8,0,0,0,13.19,35.29Z",
    id: "id_119",
    style: {
      fill: "rgb(61, 193, 219)"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 19,
    y: 56,
    width: 14,
    height: 2,
    id: "id_120",
    style: {
      fill: "rgb(90, 223, 250)"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 21,
    y: 60,
    width: 10,
    height: 2,
    id: "id_121",
    style: {
      fill: "rgb(0, 204, 245)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57,15.08V12.92a2.042,2.042,0,0,0-2.046-2.029,14.3,14.3,0,0,0-.707-1.764,2.013,2.013,0,0,0,0-2.854L52.728,4.754a2.081,2.081,0,0,0-1.445-.594,2.1,2.1,0,0,0-1.451.6A13.362,13.362,0,0,0,48.1,4.02,2.023,2.023,0,0,0,46.08,2H43.92a2.006,2.006,0,0,0-2.005,2.045,13.683,13.683,0,0,0-1.788.708,2.062,2.062,0,0,0-2.854,0L35.754,6.272a2.005,2.005,0,0,0-.594,1.445,2.08,2.08,0,0,0,.144.734,18.6,18.6,0,0,0-7.166-2.334A19.6,19.6,0,0,0,26,6q-.8,0-1.582.065l.166,1.993Q25.284,8,26,8a17.6,17.6,0,0,1,1.919.105A16.693,16.693,0,0,1,42.681,22.824a16.376,16.376,0,0,1-3.818,12.4A27.76,27.76,0,0,0,33.2,48H30V31h1v1a1,1,0,0,0,1,1h4a1,1,0,0,0,1-1V28a1,1,0,0,0-1-1H32a1,1,0,0,0-1,1v1H29a1,1,0,0,0-1,1V48H27V24a1,1,0,0,0-1-1H24V22a1,1,0,0,0-1-1H19a1,1,0,0,0-1,1v4a1,1,0,0,0,1,1h4a1,1,0,0,0,1-1V25h1V48H24V33a1,1,0,0,0-1-1H21V31a1,1,0,0,0-1-1H16a1,1,0,0,0-1,1v4a1,1,0,0,0,1,1h4a1,1,0,0,0,1-1V34h1V48H18.848c-.007-.05-.009-.1-.017-.146L17.842,48l.989-.148c-.076-.508-.176-1.027-.3-1.552l-1.947.455q.163.706.268,1.393h0A12.83,12.83,0,0,1,17,50v3a1,1,0,0,0,1,1H34a1,1,0,0,0,1-1V50.043a25.372,25.372,0,0,1,5.39-13.527A18.3,18.3,0,0,0,44.7,26H46.08a2.042,2.042,0,0,0,2.029-2.046,14.3,14.3,0,0,0,1.764-.707,2.064,2.064,0,0,0,2.854,0l1.519-1.519a2.005,2.005,0,0,0,.594-1.445,2.1,2.1,0,0,0-.6-1.451A13.705,13.705,0,0,0,54.98,17.1,2.023,2.023,0,0,0,57,15.08ZM33,29h2v2H33ZM22,25H20V23h2Zm-3,9H17V32h2ZM33,52H19V50H33Zm7.249-39.5A4.992,4.992,0,1,1,45,19a4.848,4.848,0,0,1-1.154-.153A18.526,18.526,0,0,0,40.249,12.5Zm12.8,4a8.447,8.447,0,0,1-.577,1.4,2,2,0,0,0-.238.943,2.167,2.167,0,0,0,.6,1.472l-1.546,1.521a2.022,2.022,0,0,0-2.379-.37,8.818,8.818,0,0,1-1.387.58A2.079,2.079,0,0,0,46.08,24H44.744c-.014-.46-.027-.92-.075-1.383-.059-.563-.146-1.118-.256-1.665.2.016.388.048.587.048a7,7,0,1,0-6.271-10.05q-.555-.508-1.149-.972a1.991,1.991,0,0,0,.19-.818,2.167,2.167,0,0,0-.6-1.472l1.546-1.521a2.022,2.022,0,0,0,2.379.37,8.516,8.516,0,0,1,1.414-.582A2.067,2.067,0,0,0,43.92,4l2.18.02a2.027,2.027,0,0,0,1.41,1.934,8.7,8.7,0,0,1,1.387.578,2.123,2.123,0,0,0,2.415-.365l1.521,1.546a2.022,2.022,0,0,0-.37,2.379,8.818,8.818,0,0,1,.58,1.387A2.079,2.079,0,0,0,55,12.92l-.04,2.18A2.011,2.011,0,0,0,53.045,16.5Z",
    id: "id_122",
    style: {
      fill: "rgb(69, 203, 230)"
    }
  }));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon2);
export default __webpack_public_path__ + "static/media/icon2.828c23c89eee12071970e12a97227e26.svg";
export { ForwardRef as ReactComponent };